/* ============================================================
   Kaotiko · PDP móvil (galería apilada + buybar position:fixed movido por TRANSFORM)
   - El buybar va fixed bottom:0 (el navegador lo deja SIEMPRE flush al fondo). El JS
     solo lo LEVANTA con transform: translateY(ty) [ty = top-(vh-bh) <= 0], nunca con
     `top` ni sticky. top = clamp(placeholderTop, dock, vh - bh): pegado abajo durante
     las fotos -> sube con la última foto -> clavado arriba (dock = headerBottom, 0 si
     el header está oculto). vh = visualViewport/innerHeight (borde inferior real).
   - El ALTO de la imagen es ESTÁTICO (svh en CSS), no se reescala con las barras.
   - Selector de tallas que SINCRONIZA el <product-form> nativo (cart drawer del tema).
   - JS: clamp del bloque (transform) + revelar la cinta en el 1er scroll + medir
     --kao-block-h. Desactiva la sticky ATC nativa de Aurora solo en kao (por CSS).
   ============================================================ */
(function () {
  var MOBILE_MQ = '(max-width: 749px)';

  // Si arrancamos en desktop, esperamos a cruzar a móvil para inicializar.
  function armMobileInit(root) {
    if (root.dataset.kaoArmed === '1') return;
    root.dataset.kaoArmed = '1';
    var mq = window.matchMedia(MOBILE_MQ);
    var fn = function () {
      if (mq.matches) initRoot(root);
    };
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  function initRoot(root) {
    if (!root || root.dataset.kaoInit === '1') return;
    // El efecto es SOLO móvil: en desktop NO ejecutamos nada (manda la PDP nativa).
    // (La sticky ATC nativa se oculta por CSS solo en <750px; en desktop sigue intacta.)
    if (!window.matchMedia(MOBILE_MQ).matches) {
      armMobileInit(root);
      return;
    }
    root.dataset.kaoInit = '1';

    // --- datos del producto ---
    var variants = readJSON(root.querySelector('[data-kao-variants]')) || [];
    var prices = readJSON(root.querySelector('[data-kao-prices]')) || {};

    // --- UI ---
    var priceEl = root.querySelector('[data-kao-price]');
    var cta = root.querySelector('[data-kao-cta]');
    var ctaText = root.querySelector('[data-kao-cta-text]');

    // --- fontanería nativa del tema ---
    var nativeForm = root.querySelector('form[action*="/cart/add"]');
    var nativeIdInput = nativeForm
      ? nativeForm.querySelector('input[name="id"]')
      : null;
    var nativeAddBtn = nativeForm
      ? nativeForm.querySelector('button[type="submit"][name="add"], button[name="add"]')
      : null;

    // estado de selección: posición de opción (1-based) -> valor
    var selected = {};
    var groups = Array.prototype.slice.call(
      root.querySelectorAll('[data-kao-group]')
    );
    groups.forEach(function (group) {
      var pos = parseInt(group.dataset.kaoGroup, 10);
      var pre = group.querySelector('.kao-sz.is-sel');
      if (pre) selected[pos] = pre.dataset.value;
    });

    function findVariant() {
      return (
        variants.find(function (v) {
          var opts = v.options || [];
          return groups.every(function (group) {
            var pos = parseInt(group.dataset.kaoGroup, 10);
            return selected[pos] != null && opts[pos - 1] === selected[pos];
          });
        }) || null
      );
    }

    function valueAvailable(pos, value) {
      return variants.some(function (v) {
        var opts = v.options || [];
        if (opts[pos - 1] !== value) return false;
        if (!v.available) return false;
        return groups.every(function (group) {
          var gpos = parseInt(group.dataset.kaoGroup, 10);
          if (gpos === pos) return true;
          return selected[gpos] == null || opts[gpos - 1] === selected[gpos];
        });
      });
    }

    function setCtaState(variant) {
      if (!cta) return;
      var ok = !!(variant && variant.available);
      cta.disabled = !ok;
      cta.classList.toggle('is-disabled', !ok);
      if (ctaText) {
        if (!variant) ctaText.textContent = ctaText.dataset.unavailable || ctaText.textContent;
        else if (!variant.available) ctaText.textContent = ctaText.dataset.soldout || ctaText.textContent;
        else ctaText.textContent = ctaText.dataset.add || ctaText.textContent;
      }
    }

    function refreshPills() {
      groups.forEach(function (group) {
        var pos = parseInt(group.dataset.kaoGroup, 10);
        group.querySelectorAll('.kao-sz').forEach(function (pill) {
          var isSel = selected[pos] === pill.dataset.value;
          pill.classList.toggle('is-sel', isSel);
          pill.setAttribute('aria-checked', isSel ? 'true' : 'false');
          var avail = valueAvailable(pos, pill.dataset.value);
          pill.classList.toggle('is-soldout', !avail);
          if (!avail) pill.setAttribute('aria-disabled', 'true');
          else pill.removeAttribute('aria-disabled');
        });
      });
    }

    function sync() {
      var variant = findVariant();
      if (variant) {
        if (nativeIdInput) nativeIdInput.value = variant.id;
        var formatted = prices[variant.id];
        if (priceEl && formatted) priceEl.innerHTML = formatted;
      }
      refreshPills();
      setCtaState(variant);
    }

    // Escribe la variante en el form nativo y dispara su botón name="add".
    function triggerAdd() {
      var variant = findVariant();
      if (!variant || !variant.available) return;
      if (nativeIdInput) nativeIdInput.value = variant.id;
      if (nativeAddBtn) {
        nativeAddBtn.click(); // toda la lógica del tema (AJAX + cart drawer)
      } else if (nativeForm) {
        nativeForm.requestSubmit
          ? nativeForm.requestSubmit()
          : nativeForm.submit();
      }
    }

    // --- eventos: pills ---
    groups.forEach(function (group) {
      var pos = parseInt(group.dataset.kaoGroup, 10);
      group.querySelectorAll('.kao-sz').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.classList.contains('is-soldout')) return;
          selected[pos] = pill.dataset.value;
          sync();
        });
      });
    });

    // --- evento: CTA -> dispara el botón nativo del tema ---
    if (cta) {
      cta.addEventListener('click', function () {
        if (cta.disabled || cta.classList.contains('is-disabled')) return;
        triggerAdd();
      });
    }

    /* =========================================================
       POSICIONAMIENTO (solo móvil): el buybar va position:fixed y el JS calcula su
       top cada frame: top = clamp(placeholderTop, headerBottom, vh - blockH).
       - galería -> top saturado en (vh - blockH) = pegado al fondo real del viewport.
       - tras la última foto -> sube con el scroll.
       - al llegar al header -> top = headerBottom -> clavado (.is-pinned).
       Aquí vh = innerHeight/visualViewport (DINÁMICO) SOLO para reubicar el BLOQUE
       siguiendo el borde inferior real al aparecer/ocultarse las barras del
       navegador. El ALTO de la imagen NO usa esto (usa lvh en CSS), por eso la
       foto no se recorta cuando aparece la barra inferior.
       ========================================================= */
    var buybar = root.querySelector('[data-kao-buybar]');
    var placeholder = root.querySelector('[data-kao-buybar-ph]');
    var appInsetProbe = root.querySelector('[data-kao-app-binset]');
    var appTopProbe = root.querySelector('[data-kao-app-tinset]');
    var mql = window.matchMedia('(max-width: 749px)');
    var blockH = 0;
    var wasPinned = false;
    var headerEl = null;
    var headerObserver = null;
    var animUntil = 0;
    var animRunning = false;
    var trustEl = root.querySelector('.kao-trust');
    var trustShown = false;
    var vv = window.visualViewport;

    // Header sticky real del tema ([mobile-sticky]; se oculta con translateY(-100%)).
    function findHeaderEl() {
      return (
        document.querySelector('[mobile-sticky]') ||
        document.querySelector('header-component[is-sticky]') ||
        document.querySelector('header-component') ||
        document.querySelector('.shopify-section-group-header-group .header') ||
        document.querySelector('.header')
      );
    }
    // Borde inferior ACTUAL del header (0 si está oculto por translate). Refleja
    // el transform, así el bloque sigue al header durante su animación.
    function headerH() {
      if (!headerEl || !headerEl.isConnected) acquireHeader();
      if (headerEl) return Math.max(0, headerEl.getBoundingClientRect().bottom);
      var v = getComputedStyle(document.documentElement)
        .getPropertyValue('--gsc-header-height')
        .trim();
      var n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    }
    // Bucle rAF para reubicar el bloque mientras el header se oculta/aparece
    // (su animación puede no disparar eventos de scroll).
    function pumpAnim() {
      updatePos();
      if (performance.now() < animUntil) requestAnimationFrame(pumpAnim);
      else animRunning = false;
    }
    function kickAnim(ms) {
      animUntil = Math.max(animUntil, performance.now() + ms);
      if (!animRunning) {
        animRunning = true;
        requestAnimationFrame(pumpAnim);
      }
    }
    function onHeaderTransition(e) {
      if (!e.propertyName || e.propertyName === 'transform') kickAnim(500);
    }
    function acquireHeader() {
      var el = findHeaderEl();
      if (el === headerEl) return;
      if (headerObserver) {
        headerObserver.disconnect();
        headerObserver = null;
      }
      headerEl = el;
      if (!headerEl) return;
      headerObserver = new MutationObserver(function () {
        kickAnim(500);
      });
      headerObserver.observe(headerEl, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'class', 'style']
      });
      headerEl.addEventListener('transitionrun', onHeaderTransition, { passive: true });
      headerEl.addEventListener('transitionstart', onHeaderTransition, { passive: true });
      headerEl.addEventListener('transitionend', updatePos, { passive: true });
    }

    // vh DINÁMICO (visualViewport/innerHeight) SOLO para el clamp del bloque.
    // NO se usa para el alto de la imagen (eso es lvh, estable, en CSS).
    function viewportH() {
      return (vv && vv.height) || window.innerHeight;
    }

    // Inset inferior SOLO en la app de Reskyt: alto de su barra de pestañas nativa
    // (+ safe-area), leído del probe CSS (env() + --kao-app-tabbar). Se comprueba EN
    // VIVO la clase kao-in-app (puede añadirse tarde, al inyectarse el bridge). En
    // navegador (sin .kao-in-app) el probe mide 0 -> bi=0 -> idéntico al actual.
    function bottomInset() {
      if (!appInsetProbe || !document.body) return 0;
      if (!document.body.classList.contains('kao-in-app')) return 0;
      return appInsetProbe.offsetHeight;
    }

    // Inset SUPERIOR SOLO en la app: alto de la barra superior nativa de Reskyt
    // (+ safe-area). Es el SUELO del "dock", para que al clavarse arriba el bloque
    // quede DEBAJO de esa barra y no se le tape el título/precio/tallas. 0 en navegador.
    function topInset() {
      if (!appTopProbe || !document.body) return 0;
      if (!document.body.classList.contains('kao-in-app')) return 0;
      return appTopProbe.offsetHeight;
    }

    // Mide el alto del bloque -> --kao-block-h (alto de la imagen) y lo reserva en
    // el placeholder del flujo. (No toca ninguna var de viewport.)
    function setMetrics() {
      if (!buybar) return;
      blockH = buybar.offsetHeight;
      document.documentElement.style.setProperty('--kao-block-h', blockH + 'px');
      if (placeholder) placeholder.style.height = blockH + 'px';
    }

    // Reubica el bloque (fixed top:0) con TRANSFORM (compositor), nunca con `top`.
    // Solo mueve el BLOQUE; la imagen mantiene su alto svh estático.
    function updatePos() {
      if (!buybar || !placeholder) return;
      if (!mql.matches) {
        // desktop: efecto desactivado -> limpio el transform inline (CSS lo deja estático)
        buybar.style.transform = '';
        if (wasPinned) {
          buybar.classList.remove('is-pinned');
          wasPinned = false;
        }
        return;
      }
      var dock = headerH(); // borde inferior REAL del menú (sigue su animación); 0 si oculto
      var ti = topInset(); // suelo del dock SOLO en la app (barra superior Reskyt); 0 en navegador
      if (dock < ti) dock = ti; // en la app el clavado nunca sube por detrás de la barra
      var vh = viewportH(); // borde inferior real del viewport (dinámico)
      var bh = buybar.offsetHeight;
      var bi = bottomInset(); // inset inferior SOLO en la app (tab-bar Reskyt); 0 en navegador
      var phTop = placeholder.getBoundingClientRect().top;
      // clamp(phTop, dock, vh - bh - bi): el "flush" abajo sube 'bi' para quedar SOBRE
      // la barra de pestañas de la app. En navegador bi=0 -> flush al fondo como siempre.
      var top = Math.min(Math.max(phTop, dock), vh - bh - bi);
      var docked = top <= dock + 0.5; // clavado arriba
      if (docked !== wasPinned) {
        buybar.classList.toggle('is-pinned', docked); // cambia el anclaje CSS a top:0
        wasPinned = docked;
      }
      // docked   -> anclado arriba (top:0): ty = dock  (vh-independiente -> fluido al
      //             ocultarse la barra superior; sigue al menú via dock real).
      // no-docked -> anclado abajo (bottom:0): ty = top - (vh - bh)  (0 = flush abajo).
      // En el umbral (top==dock) ambas dan el mismo top visual: cambio continuo.
      buybar.style.transform =
        'translateY(' + (docked ? dock : top - (vh - bh)) + 'px)';
    }

    // Revela la cinta en el PRIMER scroll real; remide --kao-block-h ~360ms
    // mientras se expande para que la imagen (calc(100lvh - --kao-block-h)) se
    // reajuste sin salto. La cinta colapsada da más foto al cargar.
    function revealTrustIfNeeded() {
      if (trustShown || !trustEl || !mql.matches) return;
      var scrolled = window.scrollY || (vv && vv.pageTop) || 0;
      if (scrolled <= 2) return;
      trustShown = true;
      trustEl.classList.add('is-shown');
      var until = performance.now() + 360;
      (function pump() {
        setMetrics();
        updatePos();
        if (performance.now() < until) requestAnimationFrame(pump);
      })();
    }

    var ticking = false;
    function schedule() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        revealTrustIfNeeded();
        updatePos();
        ticking = false;
      });
    }
    function onResize() {
      setMetrics();
      updatePos();
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', function () {
      setTimeout(onResize, 120);
    });
    window.addEventListener('load', function () {
      detectInApp(); // el bridge de Reskyt puede inyectarse tras el init -> re-detectar
      acquireHeader(); // el tema fija [mobile-sticky] tras su propio init
      onResize();
      // por si el bridge se inyecta aún más tarde: re-detectar y recolocar.
      setTimeout(function () { detectInApp(); onResize(); }, 600);
      setTimeout(function () { detectInApp(); onResize(); }, 1800);
    });
    if (mql.addEventListener) mql.addEventListener('change', onResize);
    else if (mql.addListener) mql.addListener(onResize); // Safari antiguo
    // visualViewport: seguir EN VIVO el borde inferior real para reubicar el BLOQUE.
    if (vv) {
      vv.addEventListener('resize', schedule);
      vv.addEventListener('scroll', schedule);
    }

    // estado inicial
    acquireHeader();
    setMetrics();
    updatePos();
    sync();
  }

  function readJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // ¿Estamos dentro del webview de Reskyt? UA case-insensitive + globals (que pueden
  // inyectarse tarde). NO se cumple en navegador normal.
  function isReskyt() {
    try {
      var ua = (navigator.userAgent || '').toLowerCase();
      return (
        ua.indexOf('rktwebview') !== -1 ||
        !!(window.reskyt || window.Reskyt || window.RktUtils || window.rkt)
      );
    } catch (e) {
      return false;
    }
  }
  // Detección -> body.kao-in-app. SOLO activa el inset de la app (tab-bar nativa).
  // En navegador normal NO se añade la clase -> nada cambia.
  function detectInApp() {
    if (isReskyt() && document.body) document.body.classList.add('kao-in-app');
  }

  function initAll() {
    detectInApp();
    document.querySelectorAll('[data-kao-pdp]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Reinicializa en el editor de temas al recargar la sección
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-kao-pdp]');
    if (root) initRoot(root);
  });
})();
